/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SelectShip } from './SelectShip';
import {
    SelectShipFromJSON,
    SelectShipFromJSONTyped,
    SelectShipToJSON,
} from './SelectShip';

/**
 * 
 * @export
 * @interface ShipSelectGet200Response
 */
export interface ShipSelectGet200Response {
    /**
     * 
     * @type {Array<SelectShip>}
     * @memberof ShipSelectGet200Response
     */
    records?: Array<SelectShip>;
}

/**
 * Check if a given object implements the ShipSelectGet200Response interface.
 */
export function instanceOfShipSelectGet200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipSelectGet200ResponseFromJSON(json: any): ShipSelectGet200Response {
    return ShipSelectGet200ResponseFromJSONTyped(json, false);
}

export function ShipSelectGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipSelectGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(SelectShipFromJSON)),
    };
}

export function ShipSelectGet200ResponseToJSON(value?: ShipSelectGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(SelectShipToJSON)),
    };
}

